// extracted by mini-css-extract-plugin
module.exports = {"NavContainer":"Header_NavContainer__20R_A","MainTitle":"Header_MainTitle__3kj_V"};